import Keycloak from "keycloak-js";
import { registerPushNotifications } from "./push/registerPush";
const kcTarget = process.env.REACT_APP_KEYCLOAK_URL;
const keycloak = new Keycloak({
  url: kcTarget,
  realm: "dartmin",
  clientId: "dart-admin",
});

let initialized = false;

function startTokenRefresh() {
  setInterval(async () => {
    try {
      // refresht, wenn Token < 60s Restlaufzeit
      const refreshed = await keycloak.updateToken(60);
      if (refreshed) {
        // optional: Debug
        console.debug("Keycloak token refreshed");
      }
    } catch (err) {
      console.error("Token refresh failed, logging out", err);
      keycloak.logout();
    }
  }, 30_000); // alle 30 Sekunden prüfen
}

export async function initKeycloak(options?: any) {
  if (initialized) {
    return keycloak.authenticated ?? false;
  }
  initialized = true;

  const authenticated = await keycloak.init({
    onLoad: "check-sso",
    pkceMethod: "S256",
    checkLoginIframe: false, // WICHTIG bei Cross-Domain
    adapter: "default", // WICHTIG: sonst Cordova-Adapter in der Capacitor-App -> weißer Bildschirm
    ...options,
  });

  if (authenticated) {
    startTokenRefresh();
    registerPushNotifications(() => keycloak.token);
  }

  return authenticated;
}


export default keycloak;
